type UsageWindow = Window & {
	CGAgentGuard?: {
		getRequestContext?():
			| { sessionId?: unknown; actionId?: unknown }
			| undefined
	}
}
const opaque = (value: unknown): value is string =>
	typeof value === 'string' && /^[A-Za-z0-9_-]{8,128}$/.test(value)

/** Opaque browser hints, never authorization, identity proof or a claim of human input. */
export function usageRequestHeaders(win: UsageWindow): Record<string, string> {
	try {
		if (win.location.origin !== 'https://app.clickguard.com') return {}
		const context = win.CGAgentGuard?.getRequestContext?.()
		if (!opaque(context?.sessionId)) return {}
		return {
			'x-cg-usage-session': context!.sessionId as string,
			...(opaque(context?.actionId)
				? { 'x-cg-usage-action': context!.actionId as string }
				: {})
		}
	} catch {
		return {}
	}
}
